import React from 'react'
import Head from 'next/head'

interface Props {
    title: string
    description: string
    authorName: string
    datePublished: string
    dateModified: string
}

function ArticleSchemaData({ title, description, authorName, datePublished, dateModified }: Props) {
    const data = {
        '@context': 'https://schema.org',
        '@type': 'ScholarlyArticle',
        headline: title,
        description: description,
        author: {
            '@type': 'Person',
            name: authorName,
        },
        datePublished: datePublished,
        dateModified: dateModified,
        publisher: {
            '@type': 'Organization',
            name: 'Knowunity',
            logo: {
                '@type': 'ImageObject',
                url: '/knowunity_logo.webp',
            },
        },
    }

    return (
        <Head>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Head>
    )
}

export default ArticleSchemaData
